import { makeAutoObservable, reaction, runInAction } from "mobx";
import agent from "../api/agent";
import { Photo } from "../models/common";
import {
  PlayerProfile,
  PlayerProfileFormValues,
} from "../models/playerProfile";
import { store } from "./store";

export default class PlayerProfileStore {
  profile: PlayerProfile | null = null;
  followings: PlayerProfile[] = [];
  photo: Photo | null = null;
  loadingProfile = false;
  uploadingPhoto = false;
  loadingFollowings = false;
  loading = false;
  activeTab: number = -1;

  constructor() {
    makeAutoObservable(this);

    reaction(
      () => this.activeTab,
      (activeTab) => {
        if (
          (this.isCurrentPlayer && (activeTab === 2 || activeTab === 3)) ||
          (!this.isCurrentPlayer && (activeTab === 0 || activeTab === 1))
        ) {
          let predicate;
          if (this.isCurrentPlayer) {
            predicate = activeTab === 2 ? "followers" : "following";
          } else {
            predicate = activeTab === 0 ? "followers" : "following";
          }
        } else {
          this.followings = [];
        }
      }
    );
  }

  resetProfile = () => {
    this.profile = null;
    this.followings = [];
    this.photo = null;
  };

  uploadPhoto = async (file: Blob) => {
    this.uploadingPhoto = true;
    try {
      const response = await agent.UserProfile.uploadPhoto(file);
      const photo = response.data;
      runInAction(() => {
        if (photo) {
          store.userStore.user!.image = photo.url;
          this.photo = photo;
        }
        this.uploadingPhoto = false;
      });
    } catch (error) {
      console.log(error);
      runInAction(() => (this.uploadingPhoto = false));
    }
  };

  deletePhoto = async () => {
    this.uploadingPhoto = true;
    try {
      await agent.UserProfile.deletePhoto();
      runInAction(() => {      
          this.photo = null;
          store.userStore.user!.image = '';
          this.uploadingPhoto = false;
      });
    } catch (error) {
      runInAction(() => (this.uploadingPhoto = false));
      console.log(error);
    }
  };

  get isCurrentPlayer() {
    if (store.userStore.user && this.profile) {
      return store.userStore.user.username === this.profile.username;
    } else {
      return false;
    }
  }

  setActiveTab = (activeIndex: number) => {
    this.activeTab = activeIndex;
  };

  loadProfile = async (username: string) => {
    this.loadingProfile = true;
    try {
      const profile = await agent.UserProfile.get(username);
      runInAction(() => {
        this.profile = profile;
        this.setActiveTab(0);
        this.loadingProfile = false;
      });
    } catch (error) {
      runInAction(() => {
        this.loadingProfile = false;
      });
      console.log(error);
    }
  };

  updateProfile = async (profile: PlayerProfileFormValues) => {
    try {
      await agent.UserProfile.updateProfile(profile);
      runInAction(() => {
        this.profile = { ...this.profile!, ...profile };
      });
    } catch (error) {
      console.log(error);
    }
  };

}
